<template>
  <section class="summer-savings">
    <div class="summer-savings__content">
      <h1 class="summer-savings__title">Expert Training, Proven Certifications, Real Savings</h1>
      <div class="summer-savings__intro-wrapper">
        <div class="summer-savings__description">
          Choose the training promotion that advances your career goals - exclusive offers for
          individuals.
        </div>
        <div class="summer-savings__intro">Shop Limited-Time Savings Below</div>
      </div>
    </div>
    <div class="summer-savings__icon">
      <div class="summer-savings__icon-logo-wrapper">
        <img :src="SummerSavingsImg" alt="Summer Savings Promo" class="summer-savings__icon-logo" />
      </div>
    </div>
  </section>
</template>

<script>
import { routesRules } from '@/helpers/mixins'
import SummerSavingsLogoPng from '@/assets/images/hero-section/summer-savings/summer-savings-logo.png'

export default {
  name: 'SummerSavingsHeroSection',
  mixins: [routesRules],
  data() {
    return {
      SummerSavingsImg: SummerSavingsLogoPng,
    }
  },
}
</script>

<style lang="scss" scoped>
.summer-savings {
  width: 100%;
  max-width: 1120px;
  color: var(--white);
  @include font-book;
  display: flex;
  flex-flow: column-reverse;
  position: relative;
  padding: 0 20px 20px 20px;
  @include mobile {
    flex-flow: row;
  }
  @include desktop {
    flex-flow: row;
    margin: auto;
    padding: 50px 0;
  }
  &__title {
    color: var(--white);
    @include font-medium;
    font-size: rem(35px);
    font-style: normal;
    font-weight: 900;
    line-height: rem(37px);
    margin: 0;
    @include mobile {
      font-size: rem(40px);
    }
    @include desktop {
      font-size: rem(54px);
      line-height: rem(50px);
    }
  }
  &__intro {
    font-size: rem(17px);
    font-style: normal;
    font-weight: 700;
    line-height: rem(26px);
    margin-top: 24px;
    @include desktop {
      font-size: rem(24px);
      line-height: rem(32px);
    }
  }
  &__description {
    color: var(--light-blue-gray);
    font-size: rem(17px);
    font-style: normal;
    font-weight: 450;
    line-height: rem(26px);
    width: 100%;
    @include mobile {
      width: 90%;
    }
    @include desktop {
      width: 85%;
      font-size: rem(24px);
      line-height: rem(32px);
    }
  }
  &__content {
    display: flex;
    flex-flow: column;
    gap: 20px;
    @include mobile {
      margin-top: 70px;
    }
    &--mt-10 {
    }
  }
  &__icon {
    position: relative;
    &-logo {
      width: 100%;
    }
    &-logo-wrapper {
      margin-bottom: 20px;
      display: flex;
      justify-content: center;
      @include mobile {
        width: 300px;
        height: unset;
      }
      @include desktop {
        width: 515px;
        height: 440px;
      }
    }
  }
}
</style>
